webpackJsonp([70],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(51)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(57),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b841a2da",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(52)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(58),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(60);



var home = function home() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 72));
};
var Recharge = function Recharge() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 70));
};
var recharge1 = function recharge1() {
  return __webpack_require__.e/* import() */(60).then(__webpack_require__.bind(null, 101));
};
var pay = function pay() {
  return __webpack_require__.e/* import() */(59).then(__webpack_require__.bind(null, 102));
};

var news = function news() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 73));
};
var detail = function detail() {
  return __webpack_require__.e/* import() */(67).then(__webpack_require__.bind(null, 74));
};
var newsList = function newsList() {
  return __webpack_require__.e/* import() */(66).then(__webpack_require__.bind(null, 75));
};
var allNews = function allNews() {
  return __webpack_require__.e/* import() */(63).then(__webpack_require__.bind(null, 78));
};
var afficheNews = function afficheNews() {
  return __webpack_require__.e/* import() */(64).then(__webpack_require__.bind(null, 77));
};
var activityNews = function activityNews() {
  return __webpack_require__.e/* import() */(65).then(__webpack_require__.bind(null, 76));
};
var gameNews = function gameNews() {
  return __webpack_require__.e/* import() */(62).then(__webpack_require__.bind(null, 79));
};
var strategy = function strategy() {
  return __webpack_require__.e/* import() */(61).then(__webpack_require__.bind(null, 80));
};

var retrievePassword = function retrievePassword() {
  return __webpack_require__.e/* import() */(58).then(__webpack_require__.bind(null, 103));
};
var retrievePasswordMessage = function retrievePasswordMessage() {
  return __webpack_require__.e/* import() */(47).then(__webpack_require__.bind(null, 105));
};
var changePassword = function changePassword() {
  return __webpack_require__.e/* import() */(57).then(__webpack_require__.bind(null, 106));
};
var retrievePasswordMpho = function retrievePasswordMpho() {
  return __webpack_require__.e/* import() */(55).then(__webpack_require__.bind(null, 108));
};
var retrievePasswordMemail = function retrievePasswordMemail() {
  return __webpack_require__.e/* import() */(56).then(__webpack_require__.bind(null, 107));
};
var retrievePasswordSucce = function retrievePasswordSucce() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 109));
};
var retrievePasswordPSucce = function retrievePasswordPSucce() {
  return __webpack_require__.e/* import() */(52).then(__webpack_require__.bind(null, 112));
};
var retrievePasswordESucce = function retrievePasswordESucce() {
  return __webpack_require__.e/* import() */(54).then(__webpack_require__.bind(null, 110));
};
var retrievePasswordEmSucce = function retrievePasswordEmSucce() {
  return __webpack_require__.e/* import() */(53).then(__webpack_require__.bind(null, 111));
};
var choose = function choose() {
  return __webpack_require__.e/* import() */(48).then(__webpack_require__.bind(null, 104));
};

var personage = function personage() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 81));
};
var modified = function modified() {
  return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 88));
};
var person = function person() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 95));
};
var mystery = function mystery() {
  return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 89));
};
var mystery2 = function mystery2() {
  return __webpack_require__.e/* import() */(50).then(__webpack_require__.bind(null, 90));
};
var mystery3 = function mystery3() {
  return __webpack_require__.e/* import() */(49).then(__webpack_require__.bind(null, 91));
};
var mysterySucce = function mysterySucce() {
  return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 92));
};
var record = function record() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 98));
};
var email = function email() {
  return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 85));
};
var email2 = function email2() {
  return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 86));
};
var bindMail = function bindMail() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 87));
};
var changemail = function changemail() {
  return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 82));
};
var newemail = function newemail() {
  return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 93));
};
var pho = function pho() {
  return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 96));
};
var phosucce = function phosucce() {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 97));
};
var changepho = function changepho() {
  return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 83));
};
var changephoSucce = function changephoSucce() {
  return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 84));
};
var relievepho = function relievepho() {
  return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 99));
};
var relievephoSucce = function relievephoSucce() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 100));
};
var password = function password() {
  return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 94));
};
var custody = function custody() {
  return __webpack_require__.e/* import() */(68).then(__webpack_require__.bind(null, 71));
};

var cwby = function cwby() {
  return __webpack_require__.e/* import() */(46).then(__webpack_require__.bind(null, 113));
};
var ztsg = function ztsg() {
  return __webpack_require__.e/* import() */(45).then(__webpack_require__.bind(null, 117));
};
var kingofrebirth = function kingofrebirth() {
  return __webpack_require__.e/* import() */(51).then(__webpack_require__.bind(null, 115));
};
var idlerancher = function idlerancher() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 114));
};
var mystage = function mystage() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 116));
};

var customerSystem = function customerSystem() {
  return __webpack_require__.e/* import() */(43).then(__webpack_require__.bind(null, 125));
};
var appeal = function appeal() {
  return __webpack_require__.e/* import() */(44).then(__webpack_require__.bind(null, 118));
};
var popup = function popup() {
  return __webpack_require__.e/* import() */(42).then(__webpack_require__.bind(null, 126));
};
var progress = function progress() {
  return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 127));
};
var payProblem = function payProblem() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 122));
};
var loginProblem = function loginProblem() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 121));
};
var accountProblem = function accountProblem() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 119));
};
var report = function report() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 123));
};
var bug = function bug() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 120));
};
var suggestion = function suggestion() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 124));
};

var forum = function forum() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 128));
};
var recommond = function recommond() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 135));
};
var topic = function topic() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 137));
};
var userCenter = function userCenter() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 138));
};
var otherUser = function otherUser() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 133));
};
var profile = function profile() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 132));
};
var myPost = function myPost() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 129));
};
var notifications = function notifications() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 131));
};
var myReply = function myReply() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 130));
};
var post = function post() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 134));
};
var search = function search() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 136));
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '',
    name: 'home',
    component: home
  }, {
    path: '/recharge',
    component: Recharge,
    children: [{ path: '', component: recharge1 }, { path: 'pay', component: pay }]
  }, {
    path: '/news',
    component: news,
    children: [{ path: 'detail', component: detail }, {
      path: 'newsList',
      component: newsList,
      children: [{ path: 'allNews', component: allNews }, { path: 'afficheNews', component: afficheNews }, { path: 'activityNews', component: activityNews }, { path: 'gameNews', component: gameNews }, { path: 'strategy', component: strategy }]
    }]
  }, {
    path: '/retrievePassword',
    component: retrievePassword,
    children: [{ path: '', component: choose }, {
      path: 'retrievePasswordMessage',
      component: retrievePasswordMessage,
      children: [{ path: 'retrievePasswordMemail', component: retrievePasswordMemail }, { path: 'retrievePasswordMpho', component: retrievePasswordMpho }, { path: 'changePassword', component: changePassword }]
    }, {
      path: 'retrievePasswordSucce',
      component: retrievePasswordSucce,
      children: [{ path: 'retrievePasswordPSucce', component: retrievePasswordPSucce }, { path: 'retrievePasswordESucce', component: retrievePasswordESucce }, { path: 'retrievePasswordEmSucce', component: retrievePasswordEmSucce }]
    }]
  }, {
    path: '/personage',
    component: personage,
    children: [{ path: '', component: person }, { path: 'modified', component: modified }, { path: 'record', component: record }, { path: 'mystery', component: mystery }, { path: 'mystery2', component: mystery2 }, { path: 'mystery3', component: mystery3 }, { path: 'mysterySucce', component: mysterySucce }, { path: 'email', component: email }, { path: 'email2', component: email2 }, { path: 'bindMail', component: bindMail }, { path: 'changemail', component: changemail }, { path: 'newemail', component: newemail }, { path: 'pho', component: pho }, { path: 'phosucce', component: phosucce }, { path: 'changepho', component: changepho }, { path: 'changephoSucce', component: changephoSucce }, { path: 'relievepho', component: relievepho }, { path: 'relievephoSucce', component: relievephoSucce }, { path: 'password', component: password }]
  }, {
    path: '/custody',
    name: 'custody',
    component: custody
  }, {
    path: '/cwby',
    name: 'cwby',
    component: cwby
  }, {
    path: '/ztsg',
    name: 'ztsg',
    component: ztsg
  }, {
    path: '/kingofrebirth',
    name: 'kingofrebirth',
    component: kingofrebirth
  }, {
    path: '/squeezepage/idlerancher',
    name: 'idlerancher',
    component: idlerancher
  }, {
    path: '/mystage',
    name: 'mystage',
    component: mystage
  }, { path: '/customer', name: 'index', component: customerSystem }, { path: '/customer/appeal', name: 'appeal', component: appeal }, { path: '/customer/progress', name: 'progress', component: progress }, { path: '/customer/pay', name: 'pay', component: payProblem }, { path: '/customer/login', name: 'login', component: loginProblem }, { path: '/customer/account', name: 'account', component: accountProblem }, { path: '/customer/report', name: 'report', component: report }, { path: '/customer/bug', name: 'bug', component: bug }, { path: '/customer/suggestion', name: 'suggestion', component: suggestion }, { path: '/customer/popup', name: 'popup', component: popup }, {
    path: '/forum',
    component: forum,
    children: [{
      path: '',
      name: 'forumHome',
      component: recommond,
      meta: {
        title: '社区首页',
        group: 'forum'
      }
    }, {
      path: 'search/:keyword',
      name: 'forumSearch',
      component: search,
      meta: {
        title: '搜索',
        group: 'forum'
      }
    }, {
      path: 'user/:id',
      name: 'userHome',
      component: otherUser,
      meta: {
        title: '个人主页',
        group: 'forum'
      }
    }, {
      path: 'userCenter',
      name: 'userCenter',
      component: userCenter,
      meta: {
        title: '个人中心',
        group: 'forum'
      },
      children: [{
        path: 'profile',
        name: 'profile',
        component: profile,
        meta: {
          title: '个人资料',
          group: 'user'
        }
      }, {
        path: 'post',
        name: 'post',
        component: myPost,
        meta: {
          title: '我的帖子',
          group: 'user'
        }
      }, {
        path: 'notifications',
        name: 'notifications',
        component: notifications,
        meta: {
          title: '消息通知',
          group: 'user'
        }
      }, {
        path: 'reply',
        name: 'reply',
        component: myReply,
        meta: {
          title: '我的回复',
          group: 'user'
        }
      }]
    }, {
      path: 'topic/:id',
      name: 'topic',
      component: topic,
      meta: {
        title: '',
        group: 'forum'
      }
    }, {
      path: 'post',
      name: 'post',
      component: post,
      meta: {
        title: '发帖子',
        group: 'forum'
      }
    }]
  }]
}));

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(62);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  strict: true,
  state: {
    customerQuery: {},
    appId: '7facce953783dee693d96c42b6bf8c74',
    token: '',
    serverSign: {
      343: '3f1dc7cdbabce8a04d3c1a2d0c111e80'
    },

    forumPublic: {
      formDatas: {
        gameId: 343,
        appId: '5116a9905e03749fbbd9120cc3e787f5',
        platform: 'web',
        oldSdkToken: ''
      }
    }
  },
  mutations: {
    increment: function increment(state, para) {
      state.customerQuery = para;
    },
    token: function token(state, para) {
      state.token = para;
    },
    forumToken: function forumToken(state, para) {
      state.forumPublic.formDatas.oldSdkToken = para;
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(49)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(55),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(48)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(54),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */,
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(50)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(56),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-863f9418",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_resource__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_component_join_vue__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_component_join_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_component_join_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_component_alert_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_component_alert_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_component_alert_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_component_footer_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_component_footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_component_footer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_component_agreement_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_component_agreement_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_component_agreement_vue__);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_resource__["a" /* default */]);
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Vjoin: __WEBPACK_IMPORTED_MODULE_2__components_component_join_vue___default.a, Valert: __WEBPACK_IMPORTED_MODULE_3__components_component_alert_vue___default.a, Vagreement: __WEBPACK_IMPORTED_MODULE_5__components_component_agreement_vue___default.a, Vfooter: __WEBPACK_IMPORTED_MODULE_4__components_component_footer_vue___default.a
  },
  data: function data() {
    return {
      agreementnew: "",
      currentNum: 1,
      isLogin: false,
      popUp: '',
      path: '',
      list: '',
      headimg: '',
      headerShow: false
    };
  },

  watch: {
    '$route': function $route(to, from) {
      this.$route.name !== undefined ? this.$route.name + new Date() : this.$route + new Date();
      if (/\/customer/g.test(this.$route.path) || /\/forum/g.test(this.$route.path)) {
        this.headerShow = false;
      } else {
        this.headerShow = true;
      }

      if (/\/game/.test(this.$route.path) && !/\/game.+/.test(this.$route.path)) {
        this.currentNum = 2;
      } else if (/\/recharge/.test(this.$route.path)) {
        this.currentNum = 3;
      } else {
        this.currentNum = 1;
      }
    }
  },
  created: function created() {
    if (/\/customer/g.test(this.$route.path) || /\/forum/g.test(this.$route.path)) {
      this.headerShow = false;
    }

    var name = 'userName=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim();
      if (c.indexOf(name) == 0) this.isLogin = c.split('=')[1];
    }
    if (/\/game/.test(this.$route.path) && !/\/game.+/.test(this.$route.path)) {
      this.currentNum = 2;
    } else if (/\/recharge/.test(this.$route.path)) {
      this.currentNum = 3;
    } else {
      this.currentNum = 1;
    }

    this.$http.get(weUrl + 'headimg/index.html').then(function (data) {
      this.headimg = data.body;
    }, function (response) {});
    this.$http.get(weUrl + 'list/index.html').then(function (data) {
      var basic = data.bodyText.substring(0, data.bodyText.lastIndexOf(',')) + ']';
      this.list = JSON.parse(basic);
    }, function (response) {});
  },
  methods: {
    onAgreementChange: function onAgreementChange(val) {
      this.agreementnew = val;
    },
    onMassageChange: function onMassageChange(val) {
      this.massagenew = val;
    },
    onPopUpChange: function onPopUpChange(val) {
      this.popUp = val;
    },
    logout: function logout() {
      document.cookie = "userName=John Doe; expires=Thu, 18 Dec 2013 12:00:00 GMT";

      this.isLogin = '';
      this.$router.push({ path: '/' });
      window.location = 'http://www.r2games.com.cn/?ct=user&ac=logout';
    },
    popUpWindow: function popUpWindow(a) {
      this.popUp = a;
    },
    navClick: function navClick(a) {
      this.currentNum = a;
    }
  }
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Vagreement',
  data: function data() {
    return {
      detail: this.detail,
      newAgreement: this.agreement
    };
  },

  props: ['agreement'],
  methods: {
    check: function check() {
      this.newAgreement = '';
    }
  },
  watch: {
    agreement: function agreement(val) {
      this.newAgreement = val;
      var str = '';
      if (val == '魔力通行证注册协议') {
        str = weUrl + 'agreement/index.html';
      } else if (val == '魔力数娱-隐私政策') {
        str = weUrl + 'privacy/index.html';
      } else if (val == '魔力数娱-用户协议') {
        str = weUrl + 'useragreement/index.html';
      }
      this.$http.get(str).then(function (data) {
        var basic = data.body;
        this.detail = basic;
      }, function (response) {});
    },
    newAgreement: function newAgreement(val) {
      this.$emit("on-agreement-change", val);
    }
  },
  created: function created() {}
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Valert',
  data: function data() {
    return {
      newMassage: this.massage
    };
  },

  props: ['massage'],
  methods: {
    check: function check() {
      this.newMassage = '';
    }
  },
  watch: {
    massage: function massage(val) {
      this.newMassage = val;
    },
    newMassage: function newMassage(val) {
      this.$emit("on-massage-change", val);
    }
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Vfooter',
  data: function data() {
    return {
      messg: ''
    };
  },
  created: function created() {
    this.$http.get(weUrl + 'recommended/index.html').then(function (data) {
      this.messg = data.body;
    }, function (response) {});
  }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__alert_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__alert_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__alert_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__agreement_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__agreement_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__agreement_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_good_storage__ = __webpack_require__(20);






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Vjoin',
  components: {
    Valert: __WEBPACK_IMPORTED_MODULE_1__alert_vue___default.a, Vagreement: __WEBPACK_IMPORTED_MODULE_2__agreement_vue___default.a
  },
  props: ['webpopUp'],
  data: function data() {
    return {
      agreementnew: '',
      massagenew: '',
      popUp: this.webpopUp,
      username: '',
      phoTime: '',
      password: '',
      userError: false,
      passwordError: false,
      cookieUser: false,
      register: 2,
      registers: {
        imgSrc: weUrl + '?ct=user&ac=verify&id=1',
        traffic: {
          username: '',
          userError: false,
          password: '',
          passwordError: false,
          passwordSure: '',
          passwordSureError: false,
          name: '',
          nameError: false,
          idcard: '',
          idcardError: false,
          agree: false,
          verify: '',
          verifyError: false
        },
        pho: {
          check: '',
          phoNum: '',
          phoNumError: false,
          password: '',
          passwordError: false,
          passwordSure: '',
          passwordSureError: false,
          name: '',
          nameError: false,
          idcard: '',
          idcardError: false,
          agree: false,
          verify: '',
          verifyError: false,
          phoverify: ''
        }
      }
    };
  },

  created: function created() {
    if (sessionStorage.getItem('userName')) {
      this.username = sessionStorage.getItem('userName');
    } else {
      this.username = '';
    }
    if (localStorage.getItem('time')) {
      var that = this;
      this.phoTime = localStorage.getItem('time');
      that.settime = setInterval(function () {
        that.phoTime--;
        localStorage.setItem('time', that.phoTime);
        if (that.phoTime <= 0) {
          that.phoTime = '';
          localStorage.removeItem('time');
          clearInterval(that.settime);
        }
      }, 1000);
    }
  },
  methods: {
    onAgreementChange: function onAgreementChange(val) {
      this.agreementnew = val;
    },
    onMassageChange: function onMassageChange(val) {
      this.massagenew = val;
    },
    phoverifyblur: function phoverifyblur() {
      this.registers.pho.check = true;
    },
    toLogin: function toLogin(ev) {
      if (ev.keyCode == 13) {
        this.login();
      }
    },
    toPho: function toPho(ev) {
      if (ev.keyCode == 13) {
        this.registersPho();
      }
    },
    toTraffic: function toTraffic(ev) {
      if (ev.keyCode == 13) {
        this.registersTraffic();
      }
    },
    checkBox: function checkBox() {
      var data = this;
      for (var n = 1; n <= arguments.length; n++) {
        if (arguments.length - n > 1) {
          data = data[arguments[n]];
        } else {
          data[arguments[n]] = arguments[0];
        }
      }
    },
    retrievePassword: function retrievePassword() {
      this.popUp = '';
      this.$router.push('/retrievePassword');
    },
    changeImg: function changeImg() {
      this.registers.imgSrc = this.registers.imgSrc + '1';
    },
    hoverBox: function hoverBox() {
      var data = this;
      for (var n = 1; n <= arguments.length; n++) {
        if (arguments.length - n > 1) {
          data = data[arguments[n]];
        } else {
          data[arguments[n]] = arguments[0];
        }
      }
    },
    popUpWindow: function popUpWindow(a) {
      this.popUp = a;
    },
    checkUser: function checkUser() {
      var x = /^[0-9a-zA-Z]*$/g;
      var data = this;
      for (var n = 1; n <= arguments.length; n++) {
        if (arguments.length - n > 1) {
          data = data[arguments[n]];
        } else {
          if (arguments[0].length < 5 || arguments[0].length > 20) {
            data[arguments[n]] = true;
          } else if (x.test(arguments[0]) && /[0-9]/.test(arguments[0]) && /[a-zA-Z]/.test(arguments[0])) {
            data[arguments[n]] = false;
          } else {
            data[arguments[n]] = true;
          }
        }
      }
    },
    checkLogUser: function checkLogUser() {
      var x = /^[0-9a-zA-Z]*$/g;
      var data = this;
      for (var n = 1; n <= arguments.length; n++) {
        if (arguments.length - n > 1) {
          data = data[arguments[n]];
        } else {
          if (arguments[0].length < 5 || arguments[0].length > 20) {
            data[arguments[n]] = true;
          } else if (x.test(arguments[0])) {
            data[arguments[n]] = false;
            return;
          } else {
            data[arguments[n]] = true;
          }
        }
      }
    },
    checkPassword: function checkPassword() {
      var x = arguments[0].replace(/ /g, "");
      var y = /^[0-9a-zA-Z]*$/g;
      var data = this;
      for (var n = 1; n <= arguments.length; n++) {
        if (arguments.length - n > 1) {
          data = data[arguments[n]];
        } else {
          if (x.length < 6 || x.length > 20) {
            data[arguments[n]] = true;
          } else if (y.test(x) && /[a-zA-Z]/.test(x) && /[0-9]/.test(x)) {
            data[arguments[n]] = false;
          } else {
            data[arguments[n]] = true;
          }
        }
      }
    },
    checkPasswordSure: function checkPasswordSure(a, b) {
      this.registers.traffic.passwordSureError = !(b == a);
    },
    checkPasswordSure1: function checkPasswordSure1(a, b) {
      this.registers.pho.passwordSureError = !(b == a);
    },
    checkName: function checkName() {
      var x = /^[\u4e00-\u9fa5]+$/g;
      var data = this;
      for (var n = 1; n <= arguments.length; n++) {
        if (arguments.length - n > 1) {
          data = data[arguments[n]];
        } else {
          if (arguments[0].length < 2 || arguments[0].length > 4) {
            data[arguments[n]] = true;
          } else if (x.test(arguments[0])) {
            data[arguments[n]] = false;
          } else {
            data[arguments[n]] = true;
          }
        }
      }
    },
    checkIdcard: function checkIdcard() {
      var x = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9X]$/;
      var y = /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$/;
      var data = this;
      for (var n = 1; n <= arguments.length; n++) {
        if (arguments.length - n > 1) {
          data = data[arguments[n]];
        } else {
          if (x.test(arguments[0]) || y.test(arguments[0])) {
            data[arguments[n]] = false;
          } else {
            data[arguments[n]] = true;
          }
        }
      }
    },
    checkVerify: function checkVerify() {
      var data = this;
      for (var n = 1; n <= arguments.length; n++) {
        if (arguments.length - n > 1) {
          data = data[arguments[n]];
        } else {
          if (arguments[0].length > 0) {
            data[arguments[n]] = false;
          } else {
            data[arguments[n]] = true;
          }
        }
      }
    },
    checkPhoNum: function checkPhoNum() {
      var x = /^1[34578]\d{9}$/;
      var data = this;
      for (var n = 1; n <= arguments.length; n++) {
        if (arguments.length - n > 1) {
          data = data[arguments[n]];
        } else {
          if (x.test(arguments[0])) {
            data[arguments[n]] = false;
          } else {
            data[arguments[n]] = true;
          }
        }
      }
    },
    getMessage: function getMessage() {
      if (!this.registers.pho.phoNumError && this.registers.pho.phoNum != '') {
        var url = weUrl + '?ct=user&ac=sendInfo';
        var parmas = {
          params: {
            phone: this.registers.pho.phoNum,
            verify: this.registers.pho.verify,
            type: 1
          }
        };
        this.$http.get(url, parmas).then(function (data) {
          if (data.body.state) {
            localStorage.setItem('time', 60);
            this.phoTime = 60;
            if (localStorage.getItem('time')) {
              var that = this;
              this.phoTime = localStorage.getItem('time');
              that.settime = setInterval(function () {
                that.phoTime--;
                localStorage.setItem('time', that.phoTime);
                if (that.phoTime <= 0) {
                  that.phoTime = '';
                  localStorage.removeItem('time');
                  clearInterval(that.settime);
                }
              }, 1000);
            }
          } else {
            this.onMassageChange(data.body.message);
          }
        }, function (response) {});
      }
    },
    login: function login() {
      if (this.userError || this.passwordError || this.username == '' || this.password == '') {
        this.checkLogUser(this.username);
        this.checkPassword(this.password);
        return;
      }
      if (this.cookieUser) {
        localStorage.setItem('userName', this.username);
      }
      var url = weUrl + '?ct=user&ac=login';

      if (/customer/g.test(this.$route.path) || /forum/g.test(this.$route.path)) {
        var gameid = 343;
      }

      var parmas = {
        params: { username: this.username, password: this.password, gameid: gameid }
      };
      this.$http.get(url, parmas).then(function (data) {
        console.log(data, '登录');
        if (data.body.state) {
          if (/customer/g.test(this.$route.path)) {
            if (!data.body.data.data.token) {
              alert('请先在游戏中注册账号');
              return;
            }
            this.$store.commit('token', data.body.data.data.token);
            sessionStorage.setItem('storeJS', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.state));
          }

          __WEBPACK_IMPORTED_MODULE_3_good_storage__["a" /* default */].set('forumToken', data.body.data.data.uidtoken);

          this.isLogin = this.username;
          document.cookie = "userName=" + this.username;
          this.popUpWindow(false);
          window.location.reload();
        } else {
          this.onMassageChange(data.body.message);
        }
      }, function (response) {});
    },
    registersTraffic: function registersTraffic() {
      if (this.registers.traffic.userError || this.registers.traffic.passwordError || this.registers.traffic.passwordSureError || this.registers.traffic.nameError || this.registers.traffic.idcardError || !this.registers.traffic.verify || !this.registers.traffic.passwordSure) {
        this.checkUser(this.registers.traffic.username, 'registers', 'traffic', 'userError');
        this.checkPassword(this.registers.traffic.password, 'registers', 'traffic', 'passwordError');
        this.checkPasswordSure(this.registers.traffic.passwordSure, this.registers.traffic.password);
        this.checkName(this.registers.traffic.name, 'registers', 'traffic', 'nameError');
        this.checkIdcard(this.registers.traffic.idcard, 'registers', 'traffic', 'idcardError');
        this.checkVerify(this.registers.traffic.verify, 'registers', 'traffic', 'verifyError');
        return;
      }
      if (!this.registers.traffic.agree) {
        this.onMassageChange('请阅读并同意魔力通行证注册协议!');
        return;
      }
      this.$http.get(weUrl + '?ct=user&ac=checkVerify', { params: { verify: this.registers.traffic.verify } }).then(function (data) {
        if (data.body.state) {
          var url = weUrl + '?ct=user&ac=register';
          var parmas = {
            params: {
              username: this.registers.traffic.username,
              password: this.registers.traffic.password,
              cname: this.registers.traffic.name,
              idcard: this.registers.traffic.idcard
            }
          };
          this.$http.get(url, parmas).then(function (data) {
            if (data.body.state) {
              this.popUp = '登录';
            } else {
              this.onMassageChange(data.body.message);
            }
          }, function (response) {});
        } else {
          this.onMassageChange('验证码错误');
          this.registers.imgSrc = this.registers.imgSrc + '1';
        }
      }, function (response) {});
    },
    registersPho: function registersPho() {
      this.registers.pho.check = true;
      if (this.registers.pho.phoNumError || this.registers.pho.passwordError || this.registers.pho.passwordSureError || this.registers.pho.nameError || this.registers.pho.idcardError || !this.registers.pho.verify || !this.registers.pho.passwordSure || !this.registers.pho.phoverify) {
        this.checkPhoNum(this.registers.pho.phoNum, 'registers', 'pho', 'phoNumError');
        this.checkPassword(this.registers.pho.password, 'registers', 'pho', 'passwordError');
        this.checkPasswordSure1(this.registers.pho.passwordSure, this.registers.pho.password);
        this.checkName(this.registers.pho.name, 'registers', 'pho', 'nameError');
        this.checkIdcard(this.registers.pho.idcard, 'registers', 'pho', 'idcardError');
        this.checkVerify(this.registers.pho.verify, 'registers', 'pho', 'verifyError');
        return;
      }
      if (!this.registers.pho.agree) {
        this.onMassageChange('请阅读并同意魔力通行证注册协议!');
        return;
      }
      this.$http.get(weUrl + '?ct=user&ac=checkVerify', { params: { verify: this.registers.pho.verify } }).then(function (data) {
        if (data.body.state) {
          var url = weUrl + '?ct=user&ac=register';
          var parmas = {
            params: {
              username: this.registers.pho.phoNum,
              password: this.registers.pho.password,
              cname: this.registers.pho.name,
              idcard: this.registers.pho.idcard,
              phoneVerify: this.registers.pho.phoverify
            }
          };
          this.$http.get(url, parmas).then(function (data) {
            if (data.body.state) {
              this.popUp = '登录';
            } else {
              this.onMassageChange(data.body.message);
            }
          }, function (response) {});
        } else {
          this.onMassageChange('验证码错误');
          this.registers.imgSrc = this.registers.imgSrc + '1';
        }
      }, function (response) {});
    }
  },
  watch: {
    username: function username(val) {
      this.username = val.replace(/ /g, "");
    },
    password: function password(val) {
      this.password = val.replace(/ /g, "");
    },
    'registers.traffic.username': function registersTrafficUsername(val) {
      this.registers.traffic.username = val.replace(/ /g, "");
    },
    'registers.traffic.password': function registersTrafficPassword(val) {
      this.registers.traffic.password = val.replace(/ /g, "");
    },
    'registers.traffic.passwordSure': function registersTrafficPasswordSure(val) {
      this.registers.traffic.passwordSure = val.replace(/ /g, "");
    },
    'registers.traffic.name': function registersTrafficName(val) {
      this.registers.traffic.name = val.replace(/ /g, "");
    },
    'registers.traffic.idcard': function registersTrafficIdcard(val) {
      this.registers.traffic.idcard = val.replace(/ /g, "");
    },
    'registers.traffic.verify': function registersTrafficVerify(val) {
      this.registers.traffic.verify = val.replace(/ /g, "");
    },
    'registers.pho.phoNum': function registersPhoPhoNum(val) {
      this.registers.pho.phoNum = val.replace(/ /g, "");
    },
    'registers.pho.password': function registersPhoPassword(val) {
      this.registers.pho.password = val.replace(/ /g, "");
    },
    'registers.pho.passwordSure': function registersPhoPasswordSure(val) {
      this.registers.pho.passwordSure = val.replace(/ /g, "");
    },
    'registers.pho.name': function registersPhoName(val) {
      this.registers.pho.name = val.replace(/ /g, "");
    },
    'registers.pho.idcard': function registersPhoIdcard(val) {
      this.registers.pho.idcard = val.replace(/ /g, "");
    },
    'registers.pho.verify': function registersPhoVerify(val) {
      this.registers.pho.verify = val.replace(/ /g, "");
    },
    'registers.pho.phoverify': function registersPhoPhoverify(val) {
      this.registers.pho.phoverify = val.replace(/ /g, "");
    },
    webpopUp: function webpopUp(val) {
      this.popUp = val;
    },
    popUp: function popUp(val) {
      this.$emit("on-popUp-change", val);
    }
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype.$axios = __WEBPACK_IMPORTED_MODULE_4_axios___default.a;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 47 */,
/* 48 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 49 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 50 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 51 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 52 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */,
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Vjoin"
  }, [(_vm.popUp) ? _c('div', {
    staticClass: "black-bg"
  }, [_c('div', [_c('h5', [_vm._v(_vm._s(_vm.popUp) + " "), _c('div', {
    on: {
      "click": function($event) {
        return _vm.popUpWindow(false)
      }
    }
  }, [_vm._v("×")])]), _vm._v(" "), (_vm.popUp == '登录') ? _c('div', {
    on: {
      "keyup": function($event) {
        return _vm.toLogin($event)
      }
    }
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _c('div', {
    staticClass: "username"
  }, [_c('i', {
    staticClass: "icon icon-log"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "userinput",
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "blur": function($event) {
        return _vm.checkLogUser(_vm.username, 'userError')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.userError) ? _c('p', [_c('i', {
    staticClass: "icon icon-exclamation"
  }), _vm._v("5-20个小写英文字母或数字组成")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "password"
  }, [_c('i', {
    staticClass: "icon icon-password"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "userinput",
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "placeholder": "请输入密码"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "blur": function($event) {
        return _vm.checkPassword(_vm.password, 'passwordError')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.passwordError) ? _c('p', [_c('i', {
    staticClass: "icon icon-exclamation"
  }), _vm._v("6-20个数字字母混合，不含空格键")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "orther"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cookieUser),
      expression: "cookieUser"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.cookieUser) ? _vm._i(_vm.cookieUser, null) > -1 : (_vm.cookieUser)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.cookieUser,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.cookieUser = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.cookieUser = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.cookieUser = $$c
        }
      }
    }
  }), _vm._v("记住用户名\n          "), _c('a', {
    staticClass: "hovera",
    on: {
      "click": _vm.retrievePassword
    }
  }, [_vm._v("忘记密码？")])]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.login
    }
  }, [_vm._v("登录")]), _vm._v(" "), _c('p', {
    staticClass: "register"
  }, [_vm._v("没有账号？请"), _c('a', {
    on: {
      "click": function($event) {
        return _vm.popUpWindow('快速注册')
      }
    }
  }, [_vm._v("注册")])])]) : _vm._e(), _vm._v(" "), (_vm.popUp == '快速注册') ? _c('div', [(_vm.register == 1) ? _c('div', {
    staticClass: "register-content",
    on: {
      "keyup": function($event) {
        return _vm.toTraffic($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registers.traffic.username),
      expression: "registers.traffic.username"
    }],
    attrs: {
      "type": "text",
      "placeholder": "账号"
    },
    domProps: {
      "value": (_vm.registers.traffic.username)
    },
    on: {
      "blur": function($event) {
        return _vm.checkUser(_vm.registers.traffic.username, 'registers', 'traffic', 'userError')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registers.traffic, "username", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error",
    class: {
      istrue: !_vm.registers.traffic.userError
    }
  }, [(_vm.registers.traffic.userError) ? _c('i', {
    staticClass: "icon icon-exclamation"
  }) : _vm._e(), _vm._v("5-20位字母和数字混合")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registers.traffic.password),
      expression: "registers.traffic.password"
    }],
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.registers.traffic.password)
    },
    on: {
      "blur": function($event) {
        return _vm.checkPassword(_vm.registers.traffic.password, 'registers', 'traffic', 'passwordError')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registers.traffic, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error",
    class: {
      istrue: !_vm.registers.traffic.passwordError
    }
  }, [(_vm.registers.traffic.passwordError) ? _c('i', {
    staticClass: "icon icon-exclamation"
  }) : _vm._e(), _vm._v("6-20个数字字母混合，不含空格键")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registers.traffic.passwordSure),
      expression: "registers.traffic.passwordSure"
    }],
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "placeholder": "确认密码"
    },
    domProps: {
      "value": (_vm.registers.traffic.passwordSure)
    },
    on: {
      "blur": function($event) {
        return _vm.checkPasswordSure(_vm.registers.traffic.passwordSure, _vm.registers.traffic.password)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registers.traffic, "passwordSure", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error",
    class: {
      istrue: !_vm.registers.traffic.passwordSureError
    }
  }, [(_vm.registers.traffic.passwordSureError) ? _c('i', {
    staticClass: "icon icon-exclamation"
  }) : _vm._e(), _vm._v("两次输入的密码不一致")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registers.traffic.name),
      expression: "registers.traffic.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "真实姓名"
    },
    domProps: {
      "value": (_vm.registers.traffic.name)
    },
    on: {
      "blur": function($event) {
        return _vm.checkName(_vm.registers.traffic.name, 'registers', 'traffic', 'nameError')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registers.traffic, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error",
    class: {
      istrue: !_vm.registers.traffic.nameError
    }
  }, [(_vm.registers.traffic.nameError) ? _c('i', {
    staticClass: "icon icon-exclamation"
  }) : _vm._e(), _vm._v("请输入您的姓名，2至4个汉字，例如：张三")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registers.traffic.idcard),
      expression: "registers.traffic.idcard"
    }],
    attrs: {
      "type": "text",
      "placeholder": "身份证号码"
    },
    domProps: {
      "value": (_vm.registers.traffic.idcard)
    },
    on: {
      "blur": function($event) {
        return _vm.checkIdcard(_vm.registers.traffic.idcard, 'registers', 'traffic', 'idcardError')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registers.traffic, "idcard", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error",
    class: {
      istrue: !_vm.registers.traffic.idcardError
    }
  }, [(_vm.registers.traffic.idcardError) ? _c('i', {
    staticClass: "icon icon-exclamation"
  }) : _vm._e(), _vm._v("请准确填写身份证号码")]), _vm._v(" "), _c('div', {
    staticClass: "verification"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registers.traffic.verify),
      expression: "registers.traffic.verify"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.registers.traffic.verify)
    },
    on: {
      "blur": function($event) {
        return _vm.checkVerify(_vm.registers.traffic.verify, 'registers', 'traffic', 'verifyError')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registers.traffic, "verify", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.registers.imgSrc,
      "alt": ""
    },
    on: {
      "click": _vm.changeImg
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "icon icon-re",
    on: {
      "click": _vm.changeImg
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "error",
    class: {
      istrue: !_vm.registers.traffic.verifyError
    }
  }, [(_vm.registers.traffic.verifyError) ? _c('i', {
    staticClass: "icon icon-exclamation"
  }) : _vm._e(), _vm._v("请输入验证码")]), _vm._v(" "), _c('p', {
    staticClass: "agreement"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registers.traffic.agree),
      expression: "registers.traffic.agree"
    }],
    staticClass: "check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.registers.traffic.agree) ? _vm._i(_vm.registers.traffic.agree, null) > -1 : (_vm.registers.traffic.agree)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.registers.traffic.agree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.registers.traffic, "agree", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.registers.traffic, "agree", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.registers.traffic, "agree", $$c)
        }
      }
    }
  }), _c('a', {
    on: {
      "click": function($event) {
        return _vm.onAgreementChange('魔力通行证注册协议')
      }
    }
  }, [_vm._v("阅读并同意魔力通行证注册协议")])]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.registersTraffic
    }
  }, [_vm._v("快速注册")]), _vm._v(" "), _c('p', {
    staticClass: "register"
  }, [_vm._v("已注册？请"), _c('a', {
    on: {
      "click": function($event) {
        return _vm.popUpWindow('登录')
      }
    }
  }, [_vm._v("登录")])])]) : _vm._e(), _vm._v(" "), (_vm.register == 2) ? _c('div', {
    staticClass: "register-content",
    on: {
      "keyup": function($event) {
        return _vm.toPho($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registers.pho.phoNum),
      expression: "registers.pho.phoNum"
    }],
    attrs: {
      "type": "text",
      "placeholder": "手机号码"
    },
    domProps: {
      "value": (_vm.registers.pho.phoNum)
    },
    on: {
      "blur": function($event) {
        return _vm.checkPhoNum(_vm.registers.pho.phoNum, 'registers', 'pho', 'phoNumError')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registers.pho, "phoNum", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error",
    class: {
      istrue: !_vm.registers.pho.phoNumError
    }
  }, [(_vm.registers.pho.phoNumError) ? _c('i', {
    staticClass: "icon icon-exclamation"
  }) : _vm._e(), _vm._v("请输入正确的手机号")]), _vm._v(" "), _c('div', {
    staticClass: "verification"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registers.pho.verify),
      expression: "registers.pho.verify"
    }],
    attrs: {
      "type": "text",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.registers.pho.verify)
    },
    on: {
      "blur": function($event) {
        return _vm.checkVerify(_vm.registers.pho.verify, 'registers', 'pho', 'verifyError')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registers.pho, "verify", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.registers.imgSrc,
      "alt": ""
    },
    on: {
      "click": _vm.changeImg
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "icon icon-re",
    on: {
      "click": _vm.changeImg
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "error",
    class: {
      istrue: !_vm.registers.pho.verifyError
    }
  }, [(_vm.registers.pho.verifyError) ? _c('i', {
    staticClass: "icon icon-exclamation"
  }) : _vm._e(), _vm._v("请输入验证码")]), _vm._v(" "), _c('div', {
    staticClass: "getMessage"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registers.pho.phoverify),
      expression: "registers.pho.phoverify"
    }],
    attrs: {
      "type": "text",
      "placeholder": "手机验证码"
    },
    domProps: {
      "value": (_vm.registers.pho.phoverify)
    },
    on: {
      "blur": _vm.phoverifyblur,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registers.pho, "phoverify", $event.target.value)
      }
    }
  }), _vm._v(" "), (!_vm.phoTime) ? _c('div', {
    staticClass: "getMessageBtb",
    on: {
      "click": _vm.getMessage
    }
  }, [_vm._v("获取验证码")]) : _vm._e(), _vm._v(" "), (_vm.phoTime) ? _c('div', {
    staticClass: "getMessageBtbNo"
  }, [_vm._v("请稍等" + _vm._s(_vm.phoTime) + "秒")]) : _vm._e()]), _vm._v(" "), _c('p', {
    staticClass: "error",
    class: {
      istrue: _vm.registers.pho.phoverify || (!_vm.registers.pho.check)
    }
  }, [((!_vm.registers.pho.phoverify) && (_vm.registers.pho.check)) ? _c('i', {
    staticClass: "icon icon-exclamation"
  }) : _vm._e(), _vm._v("请输短信入验证码")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registers.pho.password),
      expression: "registers.pho.password"
    }],
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "placeholder": "密码"
    },
    domProps: {
      "value": (_vm.registers.pho.password)
    },
    on: {
      "blur": function($event) {
        return _vm.checkPassword(_vm.registers.pho.password, 'registers', 'pho', 'passwordError')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registers.pho, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error",
    class: {
      istrue: !_vm.registers.pho.passwordError
    }
  }, [(_vm.registers.pho.passwordError) ? _c('i', {
    staticClass: "icon icon-exclamation"
  }) : _vm._e(), _vm._v("6-20个数字字母混合，不含空格键")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registers.pho.passwordSure),
      expression: "registers.pho.passwordSure"
    }],
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "placeholder": "确认密码"
    },
    domProps: {
      "value": (_vm.registers.pho.passwordSure)
    },
    on: {
      "blur": function($event) {
        return _vm.checkPasswordSure1(_vm.registers.pho.passwordSure, _vm.registers.pho.password)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registers.pho, "passwordSure", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error",
    class: {
      istrue: !_vm.registers.pho.passwordSureError
    }
  }, [(_vm.registers.pho.passwordSureError) ? _c('i', {
    staticClass: "icon icon-exclamation"
  }) : _vm._e(), _vm._v("两次输入的密码不一致")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registers.pho.name),
      expression: "registers.pho.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "真实姓名"
    },
    domProps: {
      "value": (_vm.registers.pho.name)
    },
    on: {
      "blur": function($event) {
        return _vm.checkName(_vm.registers.pho.name, 'registers', 'pho', 'nameError')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registers.pho, "name", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error",
    class: {
      istrue: !_vm.registers.pho.nameError
    }
  }, [(_vm.registers.pho.nameError) ? _c('i', {
    staticClass: "icon icon-exclamation"
  }) : _vm._e(), _vm._v("请输入您的姓名，2至4个汉字，例如：张三")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registers.pho.idcard),
      expression: "registers.pho.idcard"
    }],
    attrs: {
      "type": "text",
      "placeholder": "身份证号码"
    },
    domProps: {
      "value": (_vm.registers.pho.idcard)
    },
    on: {
      "blur": function($event) {
        return _vm.checkIdcard(_vm.registers.pho.idcard, 'registers', 'pho', 'idcardError')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.registers.pho, "idcard", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error",
    class: {
      istrue: !_vm.registers.pho.idcardError
    }
  }, [(_vm.registers.pho.idcardError) ? _c('i', {
    staticClass: "icon icon-exclamation"
  }) : _vm._e(), _vm._v("请准确填写身份证号码")]), _vm._v(" "), _c('p', {
    staticClass: "agreement"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.registers.pho.agree),
      expression: "registers.pho.agree"
    }],
    staticClass: "check",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.registers.pho.agree) ? _vm._i(_vm.registers.pho.agree, null) > -1 : (_vm.registers.pho.agree)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.registers.pho.agree,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.registers.pho, "agree", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.registers.pho, "agree", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.registers.pho, "agree", $$c)
        }
      }
    }
  }), _c('a', {
    on: {
      "click": function($event) {
        return _vm.onAgreementChange('魔力通行证注册协议')
      }
    }
  }, [_vm._v("阅读并同意魔力通行证注册协议")])]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.registersPho
    }
  }, [_vm._v("快速注册")]), _vm._v(" "), _c('p', {
    staticClass: "register"
  }, [_vm._v("已注册？请"), _c('a', {
    on: {
      "click": function($event) {
        return _vm.popUpWindow('登录')
      }
    }
  }, [_vm._v("登录")])])]) : _vm._e()]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('Valert', {
    attrs: {
      "massage": _vm.massagenew
    },
    on: {
      "on-massage-change": _vm.onMassageChange
    }
  }), _vm._v(" "), _c('Vagreement', {
    attrs: {
      "agreement": _vm.agreementnew
    },
    on: {
      "on-agreement-change": _vm.onAgreementChange
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 55 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [(_vm.headerShow) ? _c('header', [_c('div', {
    staticClass: "header"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('h1', {
    staticClass: "left r2logo"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "left"
  }, [_c('li', {
    class: {
      current: 1 == _vm.currentNum
    },
    on: {
      "click": function($event) {
        return _vm.navClick(1)
      }
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "r2list right"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "top-gameBox cd"
  }, [_c('p', {
    staticClass: "top-ad"
  }), _vm._v(" "), _c('div', {
    staticClass: "top-lst"
  }, [_c('div', {
    staticClass: "m-topGame"
  }, [_c('h2', {
    staticClass: "title web-title"
  }, [_vm._v("手机游戏")]), _vm._v(" "), _c('ul', {
    staticClass: "u-gameLst cd"
  }, _vm._l((_vm.list), function(i, index) {
    return _c('li', {
      key: index
    }, [(i.url) ? _c('a', {
      attrs: {
        "target": "_blank",
        "href": i.url
      }
    }, [_c('span', [_vm._v(_vm._s(i.title))]), _vm._v(" "), _c('i', {
      staticClass: "icon",
      class: {
        'hot': i.type2 == 1, 'new': i.type2 == 2
      }
    })]) : _vm._e(), _vm._v(" "), (!i.url) ? _c('a', {
      attrs: {
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.onMassageChange('敬请期待')
        }
      }
    }, [_c('span', [_vm._v(_vm._s(i.title))]), _vm._v(" "), _c('i', {
      staticClass: "icon",
      class: {
        'hot': i.type2 == 1, 'new': i.type2 == 2
      }
    })]) : _vm._e()])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "header-login",
    attrs: {
      "id": "toploginForm"
    }
  }, [(_vm.isLogin) ? _c('router-link', {
    staticClass: "login",
    attrs: {
      "to": "/personage"
    }
  }, [_vm._v(_vm._s(_vm.isLogin))]) : _vm._e(), _vm._v(" "), (!_vm.isLogin) ? _c('a', {
    attrs: {
      "title": "登录"
    },
    on: {
      "click": function($event) {
        return _vm.popUpWindow('登录')
      }
    }
  }, [_vm._v("登录")]) : _vm._e(), _vm._v(" |\n        "), (!_vm.isLogin) ? _c('a', {
    attrs: {
      "title": "注册"
    },
    on: {
      "click": function($event) {
        return _vm.popUpWindow('快速注册')
      }
    }
  }, [_vm._v("注册")]) : _vm._e(), _vm._v(" "), (_vm.isLogin) ? _c('a', {
    attrs: {
      "title": "注销"
    },
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("注销")]) : _vm._e()], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('router-view'), _vm._v(" "), (_vm.currentNum != 1) ? _c('Vfooter') : _vm._e(), _vm._v(" "), _c('Vjoin', {
    attrs: {
      "webpopUp": _vm.popUp
    },
    on: {
      "on-popUp-change": _vm.onPopUpChange
    }
  }), _vm._v(" "), _c('Vagreement', {
    attrs: {
      "agreement": _vm.agreementnew
    },
    on: {
      "on-agreement-change": _vm.onAgreementChange
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "//www.r2game.com/"
    }
  }, [_vm._v("海外平台")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "//corporate.r2games.com/?ac=contact"
    }
  }, [_vm._v("客服服务")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "ewmShow"
  }, [_c('a', [_vm._v("关注微信")]), _c('div', {
    staticClass: "ewm"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "r2list-button"
  }, [_c('i', {
    staticClass: "icon-mgame"
  }), _c('span', [_vm._v("魔力游戏")])])
}]}

/***/ }),
/* 56 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "Vfooter"
  }, [_c('div', {
    staticClass: "footer"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "footer-b"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "footer-b-r"
  }, [_vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "recommend"
  }, [_c('span', [_vm._v("推荐游戏:")]), _vm._v(" "), _c('a', {
    domProps: {
      "innerHTML": _vm._s(_vm.messg)
    }
  })]), _vm._v(" "), _vm._m(3)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("健康游戏忠告")]), _vm._v(" "), _c('li', [_vm._v("抵制不良游戏")]), _vm._v(" "), _c('li', [_vm._v("拒绝盗版游戏")]), _vm._v(" "), _c('li', [_vm._v("注意自我保护")]), _vm._v(" "), _c('li', [_vm._v("谨防受骗上当")]), _vm._v(" "), _c('li', [_vm._v("适度游戏益脑")]), _vm._v(" "), _c('li', [_vm._v("沉迷游戏伤身")]), _vm._v(" "), _c('li', [_vm._v("合理安排时间")]), _vm._v(" "), _c('li', [_vm._v("享受健康生活")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer-b-l"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('div', {
    staticClass: "logo"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "footer-b-r-nav"
  }, [_c('li', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "http://corporate.r2game.com/?ac=about",
      "target": "_blank"
    }
  }, [_vm._v("关于R2")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://ch.r2games.com.cn/index.html#/game",
      "target": "_blank"
    }
  }, [_vm._v("魔力无线")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://corporate.r2game.com/?ac=contact",
      "target": "_blank"
    }
  }, [_vm._v("联系我们")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://corporate.r2game.com/join/",
      "target": "_blank"
    }
  }, [_vm._v("加入我们")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://corporate.r2game.com/?ac=contact",
      "target": "_blank"
    }
  }, [_vm._v("客服中心")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://corporate.r2game.com/?ac=contact",
      "target": "_blank"
    }
  }, [_vm._v("商务合作")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://ch.r2games.com.cn/terms_of_service.html",
      "target": "_blank"
    }
  }, [_vm._v("用户许可协议")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "http://ch.r2games.com.cn/terms_of_service.html",
      "target": "_blank"
    }
  }, [_vm._v("隐私协议")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "footer-laster"
  }, [_c('a', {
    attrs: {
      "href": "http://beian.miit.gov.cn",
      "target": "_blank"
    }
  }, [_vm._v("粤ICP备17047652号-1")]), _vm._v(" "), _c('a', [_vm._v("粤网文 [2017] 3918-769号")]), _vm._v(" "), _c('a', [_vm._v("深圳魔力数娱网络科技有限公司 ©版权所有")])])
}]}

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.newMassage) ? _c('div', {
    staticClass: "Valert"
  }, [_c('div', [_c('h5', [_vm._v("信息提示"), _c('div', {
    on: {
      "click": _vm.check
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "Valert-content"
  }, [_c('p', [_c('i'), _c('span', [_vm._v(_vm._s(_vm.newMassage))])]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.check
    }
  }, [_vm._v("确认")])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.newAgreement) ? _c('div', {
    staticClass: "Vagreement"
  }, [_c('div', [_c('h5', [_vm._v(_vm._s(_vm.newAgreement)), _c('div', {
    on: {
      "click": _vm.check
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "Valert-content"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.detail)
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.check
    }
  }, [_vm._v("确认")])])])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ })
],[46]);


// WEBPACK FOOTER //
// static/js/app.0b781450be17606d0e3c.js